import { useEffect, useState } from "react";
import {
  cleanDisplayTitle,
  looksRomanUrdu,
  peekRoman,
  toEnglishTitle,
  toRomanUrdu,
} from "../../utils/romanUrdu";

export function useRomanText(text, lang) {
  const source = text == null ? "" : String(text);
  const [value, setValue] = useState(() =>
    lang === "ur" ? peekRoman(source) || source : source,
  );

  useEffect(() => {
    if (lang !== "ur" || !source.trim()) {
      setValue(source);
      return undefined;
    }
    const cached = peekRoman(source);
    if (cached) {
      setValue(cached);
      return undefined;
    }
    let alive = true;
    toRomanUrdu(source).then((roman) => {
      if (alive) setValue(roman);
    });
    return () => {
      alive = false;
    };
  }, [source, lang]);

  return lang === "ur" ? value : source;
}

export function useLocalizedTitle(text, lang) {
  const source = cleanDisplayTitle(text);
  const [value, setValue] = useState(source);

  useEffect(() => {
    let alive = true;
    const next =
      lang === "ur"
        ? toRomanUrdu(source)
        : looksRomanUrdu(source)
          ? toEnglishTitle(source)
          : Promise.resolve(source);
    next.then((title) => {
      if (alive) setValue(title || source);
    });
    return () => {
      alive = false;
    };
  }, [source, lang]);

  return value;
}

export function LocalizedTitle({ text, lang }) {
  return useLocalizedTitle(text, lang);
}

export default function RomanText({ text, lang }) {
  return useRomanText(text, lang);
}
